import { Component } from 'react';
import { connect } from 'react-redux';

import ShareModal from 'components/common/ShareModal';
import { shareListEvent, sharingList } from 'actions/hearts';
import { withErrorBoundary } from 'components/common/MartyErrorBoundary';

export class ShareCollectionModal extends Component {
  static displayName = 'ShareCollectionModal';

  state = {
    shareToken: null
  };

  componentDidMount() {
    const { listId, showShareCollectionModal } = this.props;
    if (listId && showShareCollectionModal) {
      this.onShare(listId);
    }
  }

  componentDidUpdate(prevProps) {
    const { listId, showShareCollectionModal } = this.props;
    if (prevProps.showShareCollectionModal !== showShareCollectionModal && showShareCollectionModal) {
      this.onShare(listId);
    }
  }

  onShare = listId => {
    const { sharingList, shareListEvent } = this.props;
    this.setState({ shareToken: null });
    sharingList({ listId })
      .then(({ shareToken, listId }) => {
        this.setState({ shareToken });
        shareListEvent({ listId, shareToken });
      })
      .catch(() => {});
  };

  render() {
    const { showShareCollectionModal, onDoneModal, isInfluencerCollection = false } = this.props;
    const { shareToken } = this.state;
    const link = isInfluencerCollection ? 'collection' : 'favorites';
    return (
      <ShareModal
        heading="Share"
        contentLabel="Share This List"
        isOpen={showShareCollectionModal}
        url={shareToken ? `${window?.location.origin}/${link}/${shareToken}` : 'Getting link...'}
        toCopyLabel="Copy your share link to your clipboard."
        didCopyLabel="Your share link is copied to your clipboard."
        onClose={onDoneModal}
      />
    );
  }
}

const ConnectedShareCollectionModal = connect(() => ({}), {
  sharingList,
  shareListEvent
})(ShareCollectionModal);

export default withErrorBoundary(ShareCollectionModal.displayName, ConnectedShareCollectionModal);
